class FilterUtility
{
    static GetSelectedFilters()
    {
        let searchParams = new URLSearchParams(window.location.search);

        let selectedFilters = [];

        let brands = searchParams.get('brands');

        if(brands != null)
        {
            selectedFilters.brands = brands
                .split(',')
                .map(s => s.trim());
        }
        else
        {
            selectedFilters.brands = [];
        }

        let productLines = searchParams.get('productLines');

        if(productLines != null)
        {
            selectedFilters.productLines = productLines
                .split(',')
                .map(s => s.trim());
        }
        else
        {
            selectedFilters.productLines = [];
        }

        selectedFilters.features = {};

        for(let key of searchParams.keys())
        {
            if(key.startsWith('features[') && key.endsWith(']'))
            {
                let featureSlug = key
                    .replace('features[', '')
                    .replace(']', '');

                selectedFilters.features[featureSlug] = searchParams.get(key)
                    .split(',')
                    .map(s => s.trim());
            }
        }

        return selectedFilters;
    }

    static ApplySelectedFilters(selectedFilters)
    {
        let searchParams = new URLSearchParams(window.location.search);

        searchParams.delete('brands');
        searchParams.delete('productLines');

        for(let key of searchParams.keys())
        {
            if(key.startsWith('features[') && key.endsWith(']'))
            {
                searchParams.delete(key);
            }
        }

        //---

        if(selectedFilters.brands.length > 0)
        {
            searchParams.set('brands', selectedFilters.brands.join(','));
        }

        if(selectedFilters.productLines.length > 0)
        {
            searchParams.set('productLines', selectedFilters.productLines.join(','));
        }

        if(Object.keys(selectedFilters.features).length > 0)
        {
            for(let key in selectedFilters.features)
            {
                if(selectedFilters.features[key].length > 0)
                {
                    searchParams.set(`features[${key}]`, selectedFilters.features[key].join(','));
                }
            }
        }

        window.location.search = searchParams.toString();
    }
}

export default FilterUtility;